export default {"src":"/_next/static/media/weather-working-5.be982c64.svg","height":477,"width":460,"blurWidth":0,"blurHeight":0};